import { DetailsSharedActionPage, SharedActionPage } from './model';

import { DetailsSharedActionTypes } from './types';
import { action } from 'typesafe-actions';

export const changePage = (page: Partial<SharedActionPage>) => {
  return action(DetailsSharedActionTypes.CHANGE_ACTION_PAGE, { ...page });
};

export const resetSelectedPage = () =>
  action(DetailsSharedActionTypes.RESET_SELECTED_PAGE);

export const changePageSuccess = (page: DetailsSharedActionPage | undefined) => {
  return action(DetailsSharedActionTypes.CHANGE_ACTION_PAGE_SUCCESS, page);
};

